import { produce } from "immer";
import { ActionType, createReducer } from "typesafe-actions";

import { HospitalStateType } from "../interfaces";
import * as actions from "./actions";

type Action = ActionType<typeof actions>;

const defaultFilter = {
  page: 0,
  limit: 20,
  search: "",
};

export const initialState: HospitalStateType = {
  hospitals: [],
  hospitalRolePermissions: [],
  hospitalsTotal: 0,
  hospital: null,
  filter: { ...defaultFilter },
  hospitalFormsSettings: [],
};

const reducer = createReducer<HospitalStateType, Action>(initialState)
  .handleAction(actions.getHospitals.success, (state, action) =>
    produce(state, (nextState) => {
      const { rows, count, is_clear } = action.payload;
      nextState.hospitals = !is_clear ? [...nextState.hospitals, ...rows] : [...rows];
      nextState.hospitalsTotal = count;
    }),
  )
  .handleAction(actions.getHospital.success, (state, action) =>
    produce(state, (nextState) => {
      nextState.hospital = action.payload;
    }),
  )
  .handleAction(actions.getHospitalFormsSettings.success, (state, action) =>
    produce(state, (nextState) => {
      nextState.hospitalFormsSettings = action.payload;
    }),
  )
  .handleAction(actions.updateHospital.success, (state, action) =>
    produce(state, (nextState) => {
      nextState.hospital = action.payload.hospital;
    }),
  )
  .handleAction(actions.getHospitalPermissions.success, (state, action) =>
    produce(state, (nextState) => {
      nextState.hospitalRolePermissions = action.payload;
    }),
  )
  .handleAction(actions.updateHospitalPermission.success, (state, action) =>
    produce(state, (nextState) => {
      const { role_id, permission_id, role_permission } = action.payload;
      if (role_permission) {
        nextState.hospitalRolePermissions = [...nextState.hospitalRolePermissions, role_permission];
      } else {
        nextState.hospitalRolePermissions = nextState.hospitalRolePermissions.filter(
          (rp) => !(rp.permission_id === permission_id && rp.role_id === role_id),
        );
      }
    }),
  );

export { reducer as HospitalReducer };
